function setValue(key, value) {
    if (!(window && window.localStorage)) return;
    window.localStorage.setItem(key, value);
}

function setWithValueObj(key, value, expiry = 24 * 60 * 60, setExpire = true) {
  if (!(window && window.localStorage)) return;
  const finalObj = {
    value,
    createdAt: new Date().getTime(),
  };

  if (setExpire) {
    finalObj.expiry = expiry * 1000;
  }

  window.localStorage.setItem(key, JSON.stringify(finalObj));
}

function setObj(key, obj) {
  if (!(window && window.localStorage)) return;
  window.localStorage.setItem(key, JSON.stringify(obj));
}

function deleteItem(key) {
  if (!(window && window.localStorage)) return null;
  return window.localStorage.removeItem(key);
}

function get(key) {
  if (!(window && window.localStorage)) return null;
  const stringifiedObj = window.localStorage.getItem(key);
  if (!stringifiedObj) return null;
  return stringifiedObj;
}

function getPartialMatch(matchKey) {
  const storage = Object.entries(localStorage);
  const found = storage.filter((key) => key[0].includes(matchKey)).map((finalResult) => {
    return finalResult[0];
  });
  return found;
}

function getValueObjExpiry(key, checkExpire = true) {
  if (!(window && window.localStorage)) return null;
  const stringifiedObj = window.localStorage.getItem(key);
  if (!stringifiedObj) return null;
  const finalObj = JSON.parse(stringifiedObj);
  if (!checkExpire) {
    return finalObj.value;
  }
  if (finalObj.createdAt + finalObj.expiry > new Date().getTime()) {
    return finalObj.value;
  }
  deleteItem(key);
  return null;
}

export default {
  setValue,
  setObj,
  get,
  deleteItem,
  getPartialMatch,
  setWithValueObj,
  getValueObjExpiry
};
  